import { render } from "./FleetUpdatePhoto.vue?vue&type=template&id=6db07665&scoped=true"
import script from "./FleetUpdatePhoto.vue?vue&type=script&lang=js"
export * from "./FleetUpdatePhoto.vue?vue&type=script&lang=js"

import "./FleetUpdatePhoto.vue?vue&type=style&index=0&id=6db07665&scoped=true&lang=css"

import exportComponent from "C:\\docker\\bene_piscinas_front_end\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6db07665"]])

export default __exports__